import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { endpoints } from "../../constants/Endpoints";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  department as recoilDepart,
  exam as recoilExam,
  selectedDepartmentObject,
  selectedLanguage,
} from "../../providers/index";
import { instance } from "../../services/https/inceptors";
import EmptyIcon from "../../components/EmptyIcon/index";
import { LANGUAGES, MODULES } from "../../constants/Common";
import Actions from "../../components/Action/index";
import { useHistory } from "react-router-dom";
import ReactSelect from 'react-select';
import { Button } from "../../components/buttons";
import { showToast } from "../../utilities/toast";

const modalStyles = {
  content: {
    width: "400px",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
  },
};

const NotificationPage = () => {
  const [notification, setNotification] = useState();
  const department = useRecoilValue(recoilDepart).split("/")[1];
  const exam = useRecoilValue(recoilExam).split("/")[1];
  const [currentLanguage, setCurrentLanguage] = useRecoilState(selectedLanguage);
  const selectedDepart = useRecoilValue(selectedDepartmentObject);
  const { push } = useHistory();

  const [sendModalOpen, setSendModalOpen] = useState(false);
  const [sendMessage, setSendMessage] = useState("");
  const [sending, setSending] = useState(false);

  const getAllNotifications = async () => {
    const res = await instance.get(
      `${endpoints.getAllNotifications}?exam=${exam}&department=${department}`
    );
    setNotification(res.data);
  };

  useEffect(() => {
    getAllNotifications();
  }, []);

  const handleSend = async () => {
    if (!sendMessage.trim()) return;
    setSending(true);
    try {
      await instance.post(endpoints.sendNotification, {
        message: sendMessage,
        exam,
        department,
      });
      showToast({ type: "success", message: "Notification sent successfully!" });
      setSendMessage("");
      setSendModalOpen(false);
    } catch (err) {
      showToast({ type: "error", message: "Failed to send notification." });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="container">
      <div className="flex flex-col justify-center items-center my-4">
        <div className="d-flex gap-3">
          <div
            className="d-flex justify-content-center align-items-center rounded p-2 btn-hover c-pointer text-nowrap"
            style={{ width: "200px" }}
            onClick={() => push("/create-notification")}
          >
            Create Notification
          </div>

          <div style={{ width: "200px" }}>
            <Button className="w-100 h-100" onClick={() => setSendModalOpen(true)}>
              Send
            </Button>
          </div>
        </div>

        <div className='mt-4'>
          <h6 className='mb-1 text-center'>Select Language</h6>
          <ReactSelect
            onChange={setCurrentLanguage}
            options={selectedDepart?.languages?.map((lang) => {
              const label = Object.keys(LANGUAGES).find(
                (key) => LANGUAGES[key] === lang
              );
              return {
                value: lang,
                label: label.replace(/^./, label[0].toUpperCase()),
              };
            })}
            value={currentLanguage}
            placeholder='Select Language'
            className='w-52'
          />
        </div>
      </div>

      <div className="mt-5 m-auto w-50">
        {notification?.length ? (
          <Actions
            language={currentLanguage}
            primary={true}
            type={MODULES.NOTIFICATION}
            data={notification}
            setData={setNotification}
          />
        ) : (
          <EmptyIcon />
        )}
      </div>

      <Modal
        isOpen={sendModalOpen}
        onRequestClose={() => setSendModalOpen(false)}
        style={modalStyles}
      >
        <h5 className="mb-4">Send Notification</h5>

        <div className="mb-3">
          <label className="mb-1 d-block">Message</label>
          <textarea
            rows="4"
            className="form-control"
            placeholder="Enter message..."
            value={sendMessage}
            onChange={(e) => setSendMessage(e.target.value)}
          />
        </div>

        <div className="d-flex justify-content-end gap-2">
          <button
            className="btn btn-secondary"
            onClick={() => setSendModalOpen(false)}
          >
            Cancel
          </button>
          <Button onClick={handleSend} disabled={!sendMessage.trim() || sending}>
            {sending ? "Sending..." : "Send"}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default NotificationPage;
